import { Form, Select } from 'antd';

import { PictureComponent } from 'app/components/commons/PictureComponent/PictureComponent';
import { useEditoHotels } from 'app/hooks/data/core/admin/hotels/useEditoHotels';
import { formatHotelNameWithStars } from 'app/utils/hotels';
import { requiredRule } from 'app/utils/rules';

import { HeaderWrapper } from '../../../../HeaderWrapper/HeaderWrapper';

const { Option } = Select;

type Props = {
  fieldName: string | number;
};

export const HotelRedirectionForm = ({ fieldName }: Props) => {
  const { data: hotels } = useEditoHotels();

  return (
    <div className="actionContainer">
      <div className="arrow" />
      <HeaderWrapper title="Hotel">
        <Form.Item name={[fieldName, 'hotelId']} rules={[requiredRule]}>
          <Select
            showSearch
            optionFilterProp="children"
            placeholder="Select a hotel from the list"
            filterOption={(input, option) =>
              option?.props.key
                .toLowerCase()
                .toString()
                .includes(input.toLowerCase())
            }
          >
            {hotels?.map((hotel) => (
              <Option
                key={`${hotel.name}-${hotel.locality}-${hotel.id}`}
                value={hotel.id}
                className="select-item__option"
              >
                <div className="select-item__wrapper">
                  <div className="select-item__thumbnail">
                    <PictureComponent pictureId={hotel.cover?.path ?? ''} />
                  </div>
                  <div className="select-item__name">
                    {formatHotelNameWithStars(hotel.name, hotel.stars)}
                  </div>
                </div>
              </Option>
            ))}
          </Select>
        </Form.Item>
      </HeaderWrapper>
    </div>
  );
};
